import React from 'react'
import logo from '../img/logo.png'
import react_logo from '../img/react_logo.png'
import tux_logo from '../img/linux_logo.png'
import db_logo from '../img/db_logo.png'
import Auth from '../components/Auth'

export const AuthPage = () => {
    return (
        <div className="mui-container z-depth-4">
            <h5>Login</h5>
            <div className='logoblock'><img src={tux_logo} alt="Logo" id="grayscale"/><img src={db_logo} alt="Logo" id="grayscale"/><img src={logo} alt="Logo" id="grayscale"/><img src={react_logo} alt="Logo" id="grayscale"/></div>
              <Auth />
        </div>
    )
}